/* eslint-disable no-underscore-dangle */
import { routerMiddleware, routerReducer } from 'react-router-redux';
import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import promiseMiddleware from 'redux-promise-middleware';
import thunk from 'redux-thunk';

import { history } from './history';
import { FAIL, START, SUCCESS } from './shared/utils/constants';

import auth, { moduleName as authModuleName } from './Auth/redux/auth.redux';
import exampleStore from './Root/RootStore';


const rootReducer = combineReducers({
  ...exampleStore,
  [authModuleName]: auth,
  routing: routerReducer,
});

const composeEnhancers =
  typeof window === 'object' &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
    }) : compose;

const enhancer = composeEnhancers(
  applyMiddleware(
    routerMiddleware(history),
    promiseMiddleware({
      promiseTypeSuffixes: [START.replace('_', ''), SUCCESS.replace('_', ''), FAIL.replace('_', '')],
    }),
    thunk,
  ),
  // other store enhancers if any
);


const store = createStore(rootReducer, {}, enhancer);

// TODO Сделать условие только для dev режима
window.store = store;

export default store;



// WEBPACK FOOTER //
// ./src/store.js